(function () {
  function initMissionList(root) {
    if (!root || root.dataset.mlInit === 'true') return;
    root.dataset.mlInit = 'true';

    // 事件委托：点击任意一行的按钮，展开/收起它自己的详情面板
    root.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-mission-toggle]');
      if (!toggle) return;

      var group = toggle.closest('[data-mission-row-group]');
      var detail = group ? group.querySelector('[data-mission-detail]') : null;
      if (!detail) return;

      var isOpen = toggle.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        detail.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        detail.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-mission-list]').forEach(initMissionList);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-mission-list]');
    if (root) {
      root.dataset.mlInit = 'false';
      initMissionList(root);
    }
  });
})();
